import React from "react";
import DraftAdd from "./add";
import MedicaidDraftAdd from "./medicaidAdd";
import { useSelector } from "redux/reducer";

type DraftingFormAddProps = {
  onStateChange: (state: string) => void;
};

const DraftingForm: React.FC<DraftingFormAddProps> = ({ onStateChange }) => {
  const partner = useSelector((state) => state.partner);
  const isMedicaidEnabled = Boolean(partner?.data?.medicaid);

  return (
    <>
      <DraftAdd onStateChange={onStateChange} />
      {isMedicaidEnabled && <MedicaidDraftAdd />}
    </>
  );
};

export default DraftingForm;
